// extracted by mini-css-extract-plugin
export default {"subTitle":"SubTitle_subTitle__+pFft"};